export default __webpack_public_path__ + "img/8bf06eb3c96f9d96d4c26a01d0040287.svg";